import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Table, Icon, Row, Col, Popconfirm, Divider, Button, Input, message, Modal } from 'antd';
import { Animated } from "react-animated-css";
import HeaderContent from '../common/headercontent/HeaderContent';
import AddGroupModal from './modal/AddGroupModal';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import PasswordMask from '../common/passwordmask/PasswordMask';
import { classGenCSV } from '../../config/report';
import config from '../../config';

import './group.css';

import {
  groupList,
  groupDelete,
  groupUpdate,
} from '../../modules/group';
import {
  optionList,
} from '../../modules/option';
import {
  studentGetClassResult,
  studentGetClassReport,
} from '../../modules/student';

const REPORT_BASE_SECONDS = 8;
const REPORT_SECONDS_PER_STUDENT = 0.65;
const MEMO_BASE_SECONDS = 2;
const MEMO_SECONDS_PER_STUDENT = 0.45;

const formatDuration = (seconds) => {
  const totalSeconds = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}分${remainingSeconds}秒`;
  }

  return `${remainingSeconds}秒`;
};

const estimateReportSeconds = (selected) => {
  const studentCount = Number(selected && selected.studentCount) || 0;
  return Math.max(12, Math.ceil(REPORT_BASE_SECONDS + (studentCount * REPORT_SECONDS_PER_STUDENT)));
};

const estimateMemoSeconds = (selected) => {
  const studentCount = Number(selected && selected.studentCount) || 0;
  return Math.max(4, Math.ceil(MEMO_BASE_SECONDS + (studentCount * MEMO_SECONDS_PER_STUDENT)));
};

const showExportProgress = (messageKey, selected, startedAt, estimatedSeconds, label) => {
  const elapsedSeconds = (Date.now() - startedAt) / 1000;
  const remainingSeconds = Math.max(0, estimatedSeconds - elapsedSeconds);

  message.loading({
    key: messageKey,
    content: `正在生成 ${selected.groupId} ${label}... 已用 ${formatDuration(elapsedSeconds)}，預計 ${formatDuration(estimatedSeconds)}，剩餘約 ${formatDuration(remainingSeconds)}`,
    duration: 0
  });
};


class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addModal: false,
      selectedGroup: null,
      loading: false,
      searchText: '',
      searchedColumn: '',
      visibleReport: false,
      studentData: null,
      isGeneratingReport: false
    }
  }

  componentDidMount() {
    const { optionData } = this.props;
    this.getGroup();
    if (!optionData) {
      this.getOption();
    }
  }

  toggleAddModal = () => {
    const { addModal } = this.state;
    if (addModal) {
      this.setState({ selectedGroup: null });
    }
    this.setState({ addModal: !addModal });
  }

  onSelectGroup(groupId = null) {
    window.scrollTo(0, 0);
    this.setState({ selectedGroup: null });
    setImmediate(() => {
      this.setState({ selectedGroup: groupId });
    });
  }

  getGroup() {
    this.setState({ loading: true });
    this.props.groupList().then(
      () => {
        this.setState({ loading: false });
      },
      () => {
        this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  async genAllClassCsv() {
    const { optionData } = this.props;
    const hide = message.loading('計算中，請稍候...', 0);
    try {
      const result = await classGenCSV('', optionData.results);
      hide();
      if (result.count === 0) {
        message.warning('沒有已完成的學生記錄可匯出');
      } else {
        message.success(`已匯出 ${result.count} 筆學生記錄`);
      }
    } catch (error) {
      hide();
      message.error('匯出 CSV 失敗，請稍後再試');
    }
  }

  getOption() {
    this.props.optionList();
  }

  onDeleteConfirm(groupId) {
    const { selectedGroup } = this.state;

    this.props.groupDelete(groupId).then(
      (res) => {
        if (groupId === selectedGroup) {
          this.setState({ selectedGroup: null });
        }
        this.getGroup();
      },
      (err) => {
        this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  onInactiveConfirm(groupId) {
    const { selectedGroup } = this.state;

    this.props.groupUpdate({ status: 'inactive' }, groupId).then(
      (res) => {
        if (groupId === selectedGroup) {
          this.setState({ selectedGroup: null });
        }
        this.getGroup();
      },
      (err) => {
        this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  onEditGroup = (selected) => {
    this.setState({ selectedGroup: selected });
    this.toggleAddModal();
  }

  getQRCode = (selected) => {
    return "https://quickchart.io/qr?text=https%3A%2F%2Fhkfwslifegoal.org.hk%2Flogin%3Fclass%3D" + selected.groupId + "&size=120";
  }

  onExportMemo = async (selected) => {
    const url = `${config.api}/student/memo?groupId=${selected.groupId}&showPassword=true`;
    const messageKey = `memo-export-${selected._id || selected.groupId}`;
    const startedAt = Date.now();
    const estimatedSeconds = estimateMemoSeconds(selected);
    showExportProgress(messageKey, selected, startedAt, estimatedSeconds, '通告');
    const progressTimer = window.setInterval(() => {
      showExportProgress(messageKey, selected, startedAt, estimatedSeconds, '通告');
    }, 1000);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Memo export failed with ${response.status}`);
      }
      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);
      let alink = document.createElement('a');
      alink.href = fileURL;
      alink.download = selected.groupId + '.pdf';
      alink.click();
      window.URL.revokeObjectURL(fileURL);
      window.clearInterval(progressTimer);
      message.success({
        key: messageKey,
        content: `已生成 ${selected.groupId} 通告，用時 ${formatDuration((Date.now() - startedAt) / 1000)}`,
        duration: 3
      });
    } catch (error) {
      window.clearInterval(progressTimer);
      message.error({
        key: messageKey,
        content: `通告匯出失敗，用時 ${formatDuration((Date.now() - startedAt) / 1000)}，請稍後再試`,
        duration: 4
      });
    }
  }

  onExportExcel = async (selected) => {
    const { optionData } = this.props;
    const hide = message.loading('計算中，請稍候...', 0);
    try {
      const result = await classGenCSV(selected._id, optionData.results);
      hide();
      if (result.count === 0) {
        message.warning('沒有已完成的學生記錄可匯出');
      } else {
        message.success(`已匯出 ${result.count} 筆學生記錄`);
      }
    } catch (error) {
      hide();
      message.error('匯出 CSV 失敗，請稍後再試');
    }
  }

  onExportReports = async (selected) => {
    const url = `${config.api}/student/report?classQuotaId=${selected._id}`;
    const messageKey = `report-export-${selected._id}`;
    const startedAt = Date.now();
    const estimatedSeconds = estimateReportSeconds(selected);
    showExportProgress(messageKey, selected, startedAt, estimatedSeconds, '報告');
    const progressTimer = window.setInterval(() => {
      showExportProgress(messageKey, selected, startedAt, estimatedSeconds, '報告');
    }, 1000);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Report export failed with ${response.status}`);
      }
      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);
      let alink = document.createElement('a');
      alink.href = fileURL;
      alink.download = selected.groupId + '.zip';
      alink.click();
      window.URL.revokeObjectURL(fileURL);
      window.clearInterval(progressTimer);
      message.success({
        key: messageKey,
        content: `已生成 ${selected.groupId} 報告，用時 ${formatDuration((Date.now() - startedAt) / 1000)}`,
        duration: 3
      });
    } catch (error) {
      window.clearInterval(progressTimer);
      message.error({
        key: messageKey,
        content: `報告匯出失敗，用時 ${formatDuration((Date.now() - startedAt) / 1000)}，請稍後再試`,
        duration: 4
      });
    }
    // if (this.state.isGeneratingReport) {
    //   setTimeout(message.loading('仍然在計算中，請耐心等候...', 0), 2000);
    //   return;
    // }
    // setTimeout(message.loading('計算中，請稍候...', 0), 10000);
    // this.setState({ isGeneratingReport: true });
    // this.props.studentGetClassReport(selected._id);
    // setTimeout(function () {
    //   window.open("https://sdsadmin:sdsadmin2021@hkfwslifegoal.org.hk:3100/" + selected.groupId, '_blank');
    //   setState({ isGeneratingReport: false });
    // }, 10000);
  }

  goTo = (path) => {
    window.open(path, '_blank', 'noreferrer');
  }

  getColumnSearchProps = (dataIndex, displayName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`搜尋${displayName}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜尋
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          重設
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {

    const { addModal, selectedGroup, loading, visibleReport, studentData } = this.state;

    const columns = [{
      title: '班別帳號',
      dataIndex: 'groupId',
      key: 'groupId',
      render: (text, data) => {
        return <a onClick={() => this.goTo(`/students/${data._id}`)}>{text}</a>
      },
    }, {
      title: '密碼',
      dataIndex: 'password',
      key: 'password',
      render: (text, data) => {
        return <PasswordMask password={text} />
      }
    }, {
      title: '學校',
      dataIndex: 'name_tc',
      key: 'name_tc',
      ...this.getColumnSearchProps('name_tc', '學校(中文)'),
    }, {
      title: '年度',
      dataIndex: 'year',
      key: 'year',
      ...this.getColumnSearchProps('year', '年度'),
    }, {
      title: '班別',
      dataIndex: 'className',
      key: 'className',
      ...this.getColumnSearchProps('className', '班別'),
    }, {
      title: '學生數量',
      dataIndex: 'studentCount',
      key: 'studentCount',
    }, {
      title: '操作',
      key: '操作',
      render: (text, data) => (
        <span>
          {
            (this.props.userProfile.user && this.props.userProfile.user.role === 'admin' && this.props.userProfile.user.name == "Admin") &&
            <span>
              <a onClick={() => this.onEditGroup(data)}>編輯</a>
              <Divider type="vertical" />
            </span>
          }
          {
            (this.props.userProfile.user && this.props.userProfile.user.role === 'admin' && this.props.userProfile.user.name == "Admin") &&
            <span>
              <a onClick={() => this.onExportMemo(data)}>通告</a>
              <Divider type="vertical" />
            </span>
          }
          <img src={this.getQRCode(data)} alt='qr code' />
          <Divider type="vertical" />
          <a onClick={() => this.onExportExcel(data)}>Excel</a>


          <Divider type="vertical" />
          {
            (this.props.userProfile.user && this.props.userProfile.user.role === 'admin' && this.props.userProfile.user.name == "Admin") &&
            <a onClick={() => this.onExportReports(data)}>報告</a>
          }
          {
            (this.props.userProfile.user && this.props.userProfile.user.role === 'admin' && this.props.userProfile.user.name == "Admin") &&
            <span>
              <Divider type="vertical" />
              <Popconfirm title="刪除班別?" onConfirm={() => this.onInactiveConfirm(data._id)} okText="是" cancelText="否"><a>刪除</a></Popconfirm>
            </span>
          }
        </span>
      ),
    }
    ];

    const headerData = {
      button: {
        title: <span><Icon type="file-add" /> 新增班別/學生</span>,
        function: () => this.toggleAddModal()
      }
    };

    const headerSGroupData = (selectedGroup) ? {
      close: {
        title: <Icon type="close-square" />,
        function: () => this.onSelectGroup()
      }
    } : "";

    let data = [];
    let sGroup = [];
    if (this.props.groupData) {
      data = this.props.groupData.results.map(group => {
        return {
          _id: group._id,
          groupId: group.groupId,
          password: group.password,
          name_tc: group.school.name_tc,
          schoolId: group.school._id,
          year: group.schoolQuota.year,
          className: group.className,
          quota: group.schoolQuota.quota,
          studentCount: group.studentCount,
          schoolQuotaId: group.schoolQuotaId,
        }
      });

      if (this.props.userProfile.user && this.props.userProfile.user.role !== 'admin') {
        data = data.filter(d => d.schoolId === this.props.userProfile.user.schoolId);
      }

      sGroup = this.props.groupData.results.filter(school => school._id === selectedGroup);
    }

    return (
      <Animated animationIn="fadeIn">
        <div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
          <Row>
            <Col>
              <HeaderContent title="新增班別/學生" subtitle="新增班別/學生" data={this.props.userProfile.user && this.props.userProfile.user.role === 'admin' ? headerData : ''} />
              <Card title={
                <p className="card-title">
                  <span>{`學校年度`}</span>
                  {
                    (this.props.userProfile.user && this.props.userProfile.user.role === 'admin' && this.props.userProfile.user.name == "Admin") &&
                    <Button
                      onClick={this.genAllClassCsv.bind(this)}
                    >Download All csv</Button>
                  }
                  <span>
                    <Button
                      icon={loading ? "loading" : "reload"}
                      disabled={loading ? true : false}
                      onClick={this.getGroup.bind(this)}
                    />
                  </span>
                </p>
              }>
                <Table columns={columns} dataSource={data} loading={loading} />
              </Card>

              <AddGroupModal
                show={addModal}
                toggleAddModal={this.toggleAddModal.bind(this)}
                selected={selectedGroup}
              />
            </Col>
          </Row>
        </div>
      </Animated>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
  groupData: state.group.data,
  optionData: state.option.data,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      groupList,
      groupDelete,
      groupUpdate,
      optionList,
      studentGetClassResult,
      studentGetClassReport,
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Group));
